module.exports = __webpack_public_path__ + "static/media/PersonalManagement0e93548e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/PersonalManagement.svg
// module id = 1306
// module chunks = 0